import React, {forwardRef} from 'react';
import {translateNativeBase} from "../../../services/nativeBaseTranslator";

const Stack = forwardRef((props, ref) => {
    const { direction, children, key, nativeID, style = {}, ...rest } = props;
    return (
        <div key={key} id={nativeID} ref={ref} style={{display: "flex", flexDirection: direction ?? 'column', ...translateNativeBase({...rest}), ...style}}>
            {children}
        </div>
    );
});

export default Stack;